import React, { useState } from 'react';
import ContainerServices from './containerServices';
import { CommonUtilities } from '../../commonUtils';
import Drawer from 'react-modern-drawer';

export default function ProjectValidationErrorListing(projectDetails: any) {  
    const [ contractsAssets, setcontractsAssets]= useState<any[]>([]);
    const [ assetsListing, setassetsListing]= useState<any[]>([]);
    const [ transactionListing, settransactionListing]= useState<any[]>([]);
    const [ openFirst, setOpenFirst] = React.useState(false);
    const colorList = [{bgColor : '#ffe800'}];    

    const assetType = projectDetails?.post?.assetType;
   
    const fetchContractsField = ( ) => {
        ContainerServices.contractsAssets().then((res) => {                
            setcontractsAssets(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        })
                
    }

    const fetchAssetsListing = () => {
        ContainerServices.assetsListing().then((res) => {
            setassetsListing(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        })                
    }

    const fetchTransactionListing = () => {
        ContainerServices.transactionListing().then((res) => {
            settransactionListing(CommonUtilities.relativeDataRemapping(res.data, res.headers.original));
        })                
    }  
   
    return (<>
            
        <div onClick={() => { 
            setOpenFirst(true); 
    
            if (assetType === "Contract") {
            fetchContractsField();
            } 
            
            if (assetType === "Transactions") {
             fetchTransactionListing();
            }
            if(assetType === "assets")
                fetchAssetsListing(); 
            }
        }
   
        className="ws-12 leftFrame landing mtl pLarge">

             
            <div>  
                <span className="ws-12 ptm  ">
                    {projectDetails?.post?.errorName} ({projectDetails?.post?.assetType}) ({projectDetails?.post?.errorCounting})                                                                   
                </span>    
            </div>

        </div>            
        
        <Drawer open={openFirst}
            onClose={() => setOpenFirst(false)}
            direction='right'>

                <div className='ws-8 box pull-right'>
                    <div className="box-header-main text-bold" >
                        <h2>Project Validation Error Listing</h2>
                    </div>

                    <div className='box-content'>

                        {contractsAssets.map((post, index) => {
                            return (

                                <div key={index} className='pm ws-3'>
                                    <div className='box'>

                                        <div  className="box-header text-bold" style={{background:colorList[0]?.bgColor }} >
                                                {post.contractRefNum}{post.combineCon}
                                        </div>
                                        
                                            <div className='box-content'>
                                                        
                                                <div className="box-content ps pl pr mt ">
                                                    {post.combineKon}
                                                </div>  

                                                <div className="box-content ps pl pr mt ">
                                                    {post.statusName}
                                                </div>
                                            
                                                <div className="box-content ps pl pr mt ">
                                                    {post.contractArtist}
                                                </div>

                                                <div className="box-content ps pl pr mt ">
                                                    {post.errorName}
                                                </div>
                                            
                                            </div>

                                    </div>
                                </div>                                  
                            
                            )
                        }) }
                        {assetsListing.map((post, index) => {
                                return (

                                    <div key={index} className='pm ws-3'>
                                        <div className='box'>

                                            <div  className="box-header text-bold" style={{background:colorList[0]?.bgColor }} >
                                                {post.assetTitle}
                                            </div>
                                            
                                                <div className='box-content'>
                                                            
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.assetArtist}
                                                    </div>
                                            

                                                            
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.errorName}
                                                    </div>
                                            

                                                
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.assetType}
                                                    </div>
                                                
                                                </div>

                                        </div>
                                    </div>
                                    
                                
                                )

                            })
                        }

                        {transactionListing.map((post, index) => {
                                return (

                                    <div key={index} className='pm ws-3'>
                                        <div className='box'>

                                            <div  className="box-header text-bold" style={{background:colorList[0]?.bgColor }} >
                                                {post.uniqueID}
                                            </div>
                                            
                                                <div className='box-content'>
                                                            
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.errorName}
                                                    </div>
                                            

                                                            
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.monetaryValue}
                                                    </div>
                                            

                                                
                                                    <div className="box-content ps pl pr mt ">
                                                        {post.invoiceRef}
                                                    </div>

                                                    <div className="box-content ps pl pr mt ">
                                                        {post.royaltyPeriod}
                                                    </div>
                                                
                                                </div>

                                        </div>
                                    </div>
                                    
                                
                                )

                            })
                        }
                    </div>

                    <div className="box-footer">
                        <a className="icon-btn edit" > Export </a>
                        <button className="icon-btn delete pull-right" onClick={() => setOpenFirst(false)}> Close </button>
                    </div>

                </div>
        </Drawer>
    </>)
}